import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.832 1.082c.277 0 .542.11.738.306l7.16 7.16a2.71 2.71 0 01.789 1.911c0 .716-.283 1.403-.79 1.913l-5.975 5.975a2.711 2.711 0 01-.88.588 2.71 2.71 0 01-2.076 0 2.71 2.71 0 01-.878-.587l-7.159-7.15a1.044 1.044 0 01-.306-.739V2.126c0-.577.467-1.044 1.044-1.044h8.333zM10.4 3.17H3.543v6.856l6.852 6.845a.624.624 0 00.13.1l.073.036a.623.623 0 00.238.047.623.623 0 00.239-.047.627.627 0 00.203-.136l5.972-5.973a.623.623 0 00.181-.439.621.621 0 00-.179-.437L10.4 3.17z"
    />
    <path
      fill="currentColor"
      d="M7.717 6.29c0-.576-.467-1.043-1.043-1.043l-.14.008a1.044 1.044 0 00.14 2.08l.13-.009c.515-.064.913-.503.913-1.035zm4.866 5.754c0-.577-.467-1.044-1.044-1.044l-.139.008a1.044 1.044 0 00.14 2.08l.13-.009c.515-.064.913-.503.913-1.035z"
    />
    <path stroke="currentColor" d="M12.585 8.49l-5 1" />
  </Icon>
));
